import models from "@/models";
import { Request, Cookie } from "@xt/xtbase";
import { toLoginBase } from "./method";

const { XtAxios, XtAxios4 } = Request;

const messageSetDebounce = (wait) => {
  let timer = null;

  return (mc, ma) => {
    models.message.addMcIntoSet(mc);
    timer && clearTimeout(timer);

    timer = setTimeout(() => {
      models.message.setMessage(mc, ma);
      models.message.setMessageModalVisible(true);
    }, wait);
  };
};

export const setDebounce = messageSetDebounce(300);

XtAxios.instance.interceptors.request.use((config) => {
  if(typeof window == "undefined")
    return config;
  config.headers = {
    ...config.headers,
    "xt-host": location.host,
  };

  return config;
});

const historyKeyComp = {
  COSMOS_1001: "message.COSMOS_1001",
  COSMOS_1002: "message.COSMOS_1002",
  COSMOS_1003: "message.COSMOS_1003",
  COSMOS_1004: "message.COSMOS_1004",
  COSMOS_1005: "message.COSMOS_1005",
  COSMOS_1006: "message.COSMOS_1006",
  COSMOS_1007: "message.COSMOS_1007",
  COSMOS_1008: "message.COSMOS_1008",
  COSMOS_1009: "message.COSMOS_1009",
  COSMOS_1010: "message.COSMOS_1010",
  COSMOS_1011: "message.COSMOS_1011",
  COSMOS_1012: "message.COSMOS_1012",
  COSMOS_1013: "message.COSMOS_1013",
  COSMOS_1014: "message.COSMOS_1014",
  COSMOS_1015: "message.COSMOS_1015",
  COSMOS_1016: "message.COSMOS_1016",
  COSMOS_1017: "message.COSMOS_1017",
  COSMOS_1018: "message.COSMOS_1018",
  COSMOS_1019: "message.COSMOS_1019",
  COSMOS_1020: "message.COSMOS_1020",
  COSMOS_1021: "message.COSMOS_1021",
  COSMOS_1022: "message.COSMOS_1022",
  COSMOS_1023: "message.COSMOS_1023",
  COSMOS_1024: "message.COSMOS_1024",
  COSMOS_1025: "message.COSMOS_1025",
  COSMOS_1026: "message.COSMOS_1026",
  COSMOS_1027: "message.COSMOS_1027",
  GATEWAY_000: "message.GATEWAY_0001",
};
const getMsgKey = (mc) => (historyKeyComp[mc] || mc);

XtAxios.instance.interceptors.response.use(
  (response) => {
    const { data, config } = response;
    const { autoErrorModal = true } = config;
    if (typeof data === "object") {
      const { code, rc, mc } = data;
      if (code === 401 && !config.noHandle401) {
        Cookie.remove("token");
        // // token失效跳转登录
        toLoginBase();
      }
      // 错误信息对接
      if (rc === 1 && autoErrorModal) {
        const msgKey = getMsgKey(mc); // 历史 key 兼容
        data.mc = msgKey;
        setDebounce(msgKey, data.ma);
      }
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
